import { useState, useEffect } from "react";
import Modal from "../../components/Modal";
import { GetPayment, GetPaymentType } from "../../Services";
import AddEditPaymentType from "../../forms/payment/AddEditPayment";

const AdminPayment = () => {
  const [payments, setPayments] = useState([]);
  const [summary, setSumary] = useState(null);
  const [filteredPayments, setFilteredPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [PaymentTypes, setPaymentTypes] = useState([]);
  const [editingPaymentType, setEditingPaymentType] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // ✅ Fetch Admin Payment History
  const fetchAdminPayments = async () => {
    try {
      setLoading(true);
      const res = await GetPayment.fetchAdminPayment(); // adjust base URL if needed
      setPayments(res?.payments || []);
      setSumary(res?.summary || {});
      console.log(res.summary);
    } catch (error) {
      console.error("Failed to fetch admin payments:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAdminPayments();
    fetchPaymentTypes();
  }, []);

  const fetchPaymentTypes = async () => {
    try {
      const res = await GetPaymentType.fetchPaymentType(); // adjust base URL if needed
      setPaymentTypes(res || []);
      setFilteredPayments(res || []);

      console.log(res);
    } catch (error) {
      console.error("Failed to fetch payment types:", error);
    }
  };

  // ✅ Filter payments by search term
  useEffect(() => {
    if (!searchTerm) {
      setFilteredPayments(PaymentTypes);
      return;
    }
    const lower = searchTerm.toLowerCase();
    const filtered = PaymentTypes.filter(
      (p) =>
        p.transaction_id.toLowerCase().includes(lower) ||
        p.driver.name.toLowerCase().includes(lower) ||
        p.payment_mode.toLowerCase().includes(lower) ||
        p.status.toLowerCase().includes(lower)
    );
    setFilteredPayments(filtered);
  }, [searchTerm, PaymentTypes]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleEdit = (paymentType) => {
    setEditingPaymentType(paymentType);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this payment type?"))
      return;
    try {
      await GetPaymentType.deletePaymentType(id);
      setPaymentTypes((prev) => prev.filter((p) => p.id !== id));
    } catch (error) {
      console.error("Error deleting payment type:", error);
    }
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <h2 className="text-2xl font-bold">Admin Payment History</h2>
        </div>
        <div className="row">
          <div className="col-lg-3 col-6">
            {/* small box */}
            <div className="small-box bg-info">
              <div className="inner">
                <h3>
                  $
                  {summary?.totalEarnings !== null &&
                  summary?.totalEarnings !== undefined
                    ? summary?.totalEarnings
                    : "0"}
                </h3>
                <p>Total Earings</p>
              </div>
              <div className="icon">
                <i className="ion ion-bag" />
              </div>
            </div>
          </div>
          {/* ./col */}
          <div className="col-lg-3 col-6">
            {/* small box */}
            <div className="small-box bg-success">
              <div className="inner">
                <h3>
                  $
                  {summary?.totalTransactionAmount !== null &&
                  summary?.totalTransactionAmount !== undefined
                    ? summary?.totalTransactionAmount
                    : "0"}
                </h3>
                <p>Total transactions</p>
              </div>
              <div className="icon">
                <i className="ion ion-stats-bars" />
              </div>
            </div>
          </div>
          {/* ./col */}
          <div className="col-lg-3 col-6">
            {/* small box */}
            <div className="small-box bg-warning">
              <div className="inner">
                <h3>
                  $
                  {summary?.totalCommission !== null &&
                  summary?.totalCommission !== undefined
                    ? summary?.totalCommission
                    : "0"}
                </h3>
                <p>Total Commissions</p>
              </div>
              <div className="icon">
                <i className="ion ion-person-add" />
              </div>
            </div>
          </div>
          {/* ./col */}
          <div className="col-lg-3 col-6">
            {/* small box */}
            <div className="small-box bg-danger">
              <div className="inner">
                <h3>{payments.length}</h3>
                <p>Total Transactions</p>
              </div>

              <div className="icon">
                <i className="ion ion-pie-graph" />
              </div>
            </div>
          </div>
          {/* ./col */}
        </div>
        <div className="card">
          <div className="card-header flex items-center justify-between">
            <button
              type="button"
              className="btn btn-primary btn-sm flex items-center"
              onClick={() => setShowModal(true)}
            >
              <i className="fa fa-plus mr-1"></i> Add Payment type
            </button>
          </div>

          <Modal showModal={showModal} setShowModal={setShowModal}>
            <AddEditPaymentType
              editingPaymentType={editingPaymentType}
              setEditingPaymentType={setEditingPaymentType}
              setPaymentTypes={setPaymentTypes}
              setShowModal={setShowModal}
            />
          </Modal>

          <div className="card-body flex flex-col gap-4">
            <div className="mt-4">
              {loading ? (
                <p>Loading payment type...</p>
              ) : filteredPayments.length === 0 ? (
                <p>No payment type records found.</p>
              ) : (
                <table className="table table-bordered w-full">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Bank Name</th>
                      <th>Account Name</th>
                      <th>Account Number</th>
                      <th>Account Address</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {PaymentTypes.map((p, index) => (
                      <tr key={p.id}>
                        <td>{index + 1}</td>
                        <td>{p.bank_name}</td>
                        <td>{p.account_name}</td>
                        <td>{p.account_number}</td>
                        <td>{p.account_address}</td>
                        <td>{p.is_active ? "Active" : "Inactive"}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-primary mr-1"
                            onClick={() => handleEdit(p)} // Open edit modal
                          >
                            <i className="fas fa-edit"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => handleDelete(p.id)} // Delete driver
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>

            <div className="card-footer clearfix">
              <ul className="pagination pagination-sm m-0 float-right">
                <li className="page-item">
                  <a
                    className="page-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      if (currentPage > 1) handlePageChange(currentPage - 1);
                    }}
                  >
                    &laquo;
                  </a>
                </li>
                {[...Array(totalPages).keys()].map((page) => (
                  <li
                    className={`page-item ${
                      currentPage === page + 1 ? "active" : ""
                    }`}
                    key={page + 1}
                  >
                    <a
                      className="page-link"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handlePageChange(page + 1);
                      }}
                    >
                      {page + 1}
                    </a>
                  </li>
                ))}
                <li className="page-item">
                  <a
                    className="page-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      if (currentPage < totalPages)
                        handlePageChange(currentPage + 1);
                    }}
                  >
                    &raquo;
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* <div className="card-footer clearfix">
            <span className="text-muted text-sm">
              Showing {filteredPayments.length} of {payments.length} records
            </span>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default AdminPayment;
